// src/services/admin/AdminManagementService.js
import adminAPI from "../../api/apiAdmin";

class AdminManagementService {
    static async getAll(params = {}) {
        const response = await adminAPI.get("/admin/admins", { params });
        return response.data;
    }

    static async getDetail(id) {
        const response = await adminAPI.get(`/admin/admins/${id}`);
        return response.data;
    }

    static async create(data) {
        const response = await adminAPI.post("/admin/admins", data);
        return response.data;
    }

    static async update(id, data) {
        const response = await adminAPI.patch(`/admin/admins/${id}`, data);
        return response.data;
    }

    static async toggleStatus(id) {
        const response = await adminAPI.patch(`/admin/admins/${id}/toggle-status`);
        return response.data;
    }

    static async changeRole(id, role) {
        const response = await adminAPI.patch(`/admin/admins/${id}/change-role`, { role });
        return response.data;
    }
}

export default AdminManagementService;
